import { Media } from '@travel/ui';
import { isEmptyArray } from '@travel/utils';

import NoImageContent from 'favoriteList/components/CustomMedium/NoImageContent';
import { ServiceType } from 'favoriteList/constants/favoriteLists';
import FeatureLabels from '../FeatureLabel';
import ProviderHeader from '../ProviderHeader';
import ProviderPrice from '../ProviderPrice';

import type { ProviderWithArrayIndex } from 'Provider-Types';

import styles from './providerCard.module.scss';

type Props = {
  provider: ProviderWithArrayIndex;
  handleProviderFavoriteButtonClick: (provider: ProviderWithArrayIndex) => void;
  serviceType: ServiceType;
};

const ProviderCard = (props: Props) => {
  const { provider, handleProviderFavoriteButtonClick, serviceType } = props;
  const { lowestPrice, lowestPriceNoTax, lowestPriceDescription, media, tags } = provider;

  const photo = media && media.length > 0 ? media[0] : null;
  const isMediaEmpty = isEmptyArray(media) || media[0].url === null;
  const isDomestic = serviceType === ServiceType.DOMESTIC;

  return (
    <div className={styles.container}>
      <div className={styles.providerMedia}>
        {!isMediaEmpty ? (
          <Media url={photo?.url} alt={photo?.description} className={styles.media} />
        ) : (
          <NoImageContent mediaWrapperClassName={styles.noImageMedia} />
        )}
      </div>
      <section className={styles.contentContainer}>
        <ProviderHeader
          provider={provider}
          handleProviderFavoriteButtonClick={handleProviderFavoriteButtonClick}
          isDomestic={isDomestic}
        />
        <div className={styles.providerBody}>
          <FeatureLabels tags={tags} className={styles.featureLabels} />
          <ProviderPrice
            lowestPrice={lowestPrice}
            lowestPriceNoTax={lowestPriceNoTax}
            lowestPriceDescription={lowestPriceDescription}
            serviceType={serviceType}
          />
        </div>
      </section>
    </div>
  );
};

export default ProviderCard;
